
import { useState } from 'react';
import { Link } from 'react-router-dom';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleNavClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const leftNavItems = [
    { name: '品牌故事', path: '/brand-story' },
    { name: '产品中心', path: '/products' }
  ];

  const rightNavItems = [
    { name: '资讯动态', path: '/news' },
    { name: '联系我们', path: '/contact' }
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm">
      <div className="w-full px-8 lg:px-16 py-4">
        <div className="flex items-center justify-between lg:justify-center">
          {/* Desktop Navigation Layout */}
          <div className="hidden lg:flex items-center justify-center w-full">
            {/* Left Navigation */}
            <div className="flex items-center space-x-8">
              {leftNavItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  onClick={handleNavClick}
                  className="text-stone-700 hover:text-red-700 transition-all duration-300 font-medium cursor-pointer whitespace-nowrap relative group text-sm"
                  style={{ fontFamily: 'Noto Serif SC, serif' }}
                >
                  {item.name}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-red-700 transition-all duration-300 group-hover:w-full"></span>
                </Link>
              ))}
            </div>

            {/* Center Logo */}
            <Link to="/" onClick={handleNavClick} className="flex items-center mx-12">
              <img 
                src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/976e6673b4cf68d805b1847f5a38dafc.png" 
                alt="宫廷养森" 
                className="h-11 w-auto object-contain"
              />
            </Link>

            {/* Right Navigation */}
            <div className="flex items-center space-x-8">
              {rightNavItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  onClick={handleNavClick}
                  className="text-stone-700 hover:text-red-700 transition-all duration-300 font-medium cursor-pointer whitespace-nowrap relative group text-sm"
                  style={{ fontFamily: 'Noto Serif SC, serif' }}
                >
                  {item.name}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-red-700 transition-all duration-300 group-hover:w-full"></span>
                </Link>
              ))}
            </div>
          </div>

          {/* Mobile Layout */}
          <div className="flex lg:hidden items-center justify-between w-full">
            {/* Mobile Menu Button - Left */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="w-8 h-8 flex items-center justify-center cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`} style={{ color: '#cf3e16' }}></i>
            </button>

            {/* Logo - Center */}
            <Link to="/" onClick={handleNavClick} className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/976e6673b4cf68d805b1847f5a38dafc.png" 
                alt="宫廷养森" 
                className="h-6 w-auto object-contain"
              />
            </Link>

            {/* Empty space for balance */}
            <div className="w-8 h-8"></div>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="lg:hidden fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-40 mt-16">
              <div className="px-8 pt-6 pb-6">
                <div className="flex flex-col space-y-4">
                  {[...leftNavItems, ...rightNavItems].map((item) => (
                    <Link
                      key={item.name}
                      to={item.path}
                      className="text-stone-700 hover:text-red-700 transition-colors duration-300 font-medium cursor-pointer text-sm"
                      style={{ fontFamily: 'Noto Serif SC, serif' }}
                      onClick={() => {
                        setIsMenuOpen(false);
                        handleNavClick();
                      }}
                    >
                      {item.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
